import { Box, Flex, List, Stack, Text } from '@mantine/core';
import { Link } from 'react-router-dom';
import { Switch } from 'src/components/Form/Switch';
import { InputText } from 'src/components/Form/Text';
import { NotFound } from 'src/components/NotFound';
import { PageLoader } from 'src/components/PageLoader';
import { PageTitle } from 'src/components/PageTitle';
import { ThemeSelector } from 'src/features/interaction/common';
import { Form } from 'src/form';
import { links } from 'src/router/routes';

import { FormData, useInteractionDetails } from './use-interaction-details';
import { ActionFooter } from 'src/components/ActionFooter';

export const Interaction = () => {
  const {
    interaction,
    isPending,
    initialValues,
    validate,
    handleDelete,
    handleSubmit,
    isEditPending,
    themeOptions,
    handleCancel,
  } = useInteractionDetails();

  if (isPending) {
    return <PageLoader visible={true} />;
  }

  if (!interaction) {
    return (
      <NotFound description="The interaction you're looking for doesn't exist" />
    );
  }

  return (
    <Form<FormData>
      initialValues={initialValues}
      validate={validate}
      onSubmit={handleSubmit}
    >
      <Flex
        direction="column"
        justify="space-between"
        style={{ height: '100%' }}
      >
        <Stack gap="lg">
          <PageTitle title={interaction.name} />

          <InputText
            name="name"
            label="Interaction Name"
            placeholder="Enter interaction name"
            maxLength={30}
          />

          <List spacing="xs" listStyleType="none">
            <List.Item>
              <Text fw={500} mb="sm">
                Base Interaction
              </Text>
              <Text td="underline" size="sm">
                <Link
                  to={`${links.interactionDictionary}/${interaction.interaction_dictionary.id}`}
                >
                  <Text component="span" fw={600} style={{ cursor: 'pointer' }}>
                    {interaction.interaction_dictionary.name}
                  </Text>
                </Link>
              </Text>
            </List.Item>
          </List>

          <Box>
            <Text fw={500} mb="sm">
              Settings
            </Text>
            <Stack gap="sm">
              <Switch label="With Leaderboard" name="with_leaderboard" />
              <Switch label="With PVO" name="with_pvo" />
              <Switch label="With PVO Form" name="with_pvo_form" />
            </Stack>
          </Box>

          <ThemeSelector
            name="selected_theme_id"
            label="Theme Selection"
            themeOptions={themeOptions}
          />
        </Stack>

        <ActionFooter
          isLoading={isEditPending}
          onDelete={handleDelete}
          onCancel={handleCancel}
        />
      </Flex>
    </Form>
  );
};
